import "./registerServiceWorker";
import "./assets/pwa.css";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import VueFeather from 'vue-feather';
import PrimeVue from 'primevue/config'
import Aura from '@primevue/themes/aura'
import 'primeicons/primeicons.css'
import Tree from 'primevue/tree'
import 'nouislider/dist/nouislider.css'

import { i18n } from './i18n/index.js'
import { createPinia } from 'pinia'
import persisted from 'pinia-plugin-persistedstate'
import { useSettingsStore } from '@/stores/settings'

// Session-cookie auth: gdy frontend jest na innym porcie niż backend (np. 8080 vs 9898)
// przeglądarka wymaga credentials, aby zapisać i wysyłać JSESSIONID.
axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

async function bootstrap() {
  const app = createApp(App)

  const pinia = createPinia()
  pinia.use(persisted)
  app.use(pinia)

  app.use(i18n)

  app.use(router)
  app.use(PrimeVue, { theme: { preset: Aura } })
  app.component(VueFeather.name, VueFeather)
  app.component('Tree', Tree)

  const settings = useSettingsStore()
  await settings.init(navigator.language)

  app.mount('#app')
}
bootstrap()